import { useState } from "react";
import { Form, Offcanvas, Spinner, Table } from "react-bootstrap";
import { studyEDCDashboardGraph } from "../../../../APIServices/studyEDCDashboardGraph";

const DBPCOMPONENTS = [
  "Sites",
  "Subjects",
  "Open Notification",
  "Close Notification",
  "Open Query",
  "Close Query",
  "Answered Query",
  "Cancelled Query",
  "Auto Query",
  "Manual Query",
  "Completed SDV",
  "Pending SDV",
  "Total Form",
  "Assigned Form",
  "Reviewed Form",
  "Pending Review Form",
  "Log Form",
  "Regular Form",
  "Repeat Form",
  "Special Form",
  "Recent activity",
];

const LIVEQCCOMPONENTS = [
  "Sites",
  "Subjects",
  "Open Notification",
  "Close Notification",
  "Open Query",
  "Close Query",
  "Answered Query",
  "Cancelled Query",
  "Auto Query",
  "Manual Query",
  "Completed SDV",
  "Pending SDV",
  "Recent activity",
];

const DVCOMPONENTS = [
  "Total Form",
  "Reviewed Form",
  "Pending Review Form",
  "Log Form",
  "Regular Form",
  "Repeat Form",
  "Special Form",
  "Recent activity",
];

const AddComponents = ({
  Show,
  Hide,
  tableRef,
  onMouseDown,
  studyId,
  category,
  StudyMode,
  selected,
  setSelected,
  getStudyDashboardComponentData,
}) => {
  const [buttonLoader, setButtonLoader] = useState(false);

  const handleCheckbox = (label) => {
    setSelected((prev) =>
      prev.includes(label)
        ? prev.filter((item) => item !== label)
        : [...prev, label]
    );
  };

  const allComponents =
    StudyMode === "DBP Mode"
      ? [...(DBPCOMPONENTS || [])]
      : StudyMode === "Live Mode" || StudyMode === "QC Mode"
      ? [...(LIVEQCCOMPONENTS || [])]
      : [...(DVCOMPONENTS || [])];

  const isAllSelected = selected.length === allComponents.length;

  const toggleSelectAll = () => {
    if (isAllSelected) {
      setSelected([]);
    } else {
      setSelected(allComponents);
    }
  };

  const updateStudyDashboardComponent = async () => {
    setButtonLoader(true);
    let userData = {};
    userData.studyId = studyId;
    userData.category = category;
    userData.components = selected;
    userData.mode = StudyMode;
    let data = await studyEDCDashboardGraph.updateStudyDashboardComponent(userData);
    if (data?.statusCode === 200) {
      getStudyDashboardComponentData();
      Hide();
    }
    setButtonLoader(false);
  };

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Component List</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="p-0">
        <Table ref={tableRef} className="m-0 custom-table" hover striped>
          <thead className="position-sticky top-0">
            <tr>
              <th
                style={{ width: 45 }}
                className="text-center"
                onMouseDown={(e) => onMouseDown(e, 0)}
              >
                <Form.Check
                  type="checkbox"
                  checked={isAllSelected}
                  onChange={toggleSelectAll}
                />
              </th>
              <th onMouseDown={(e) => onMouseDown(e, 1)}>Component Label</th>
            </tr>
          </thead>
          <tbody>
            {StudyMode === "DBP Mode" &&
              DBPCOMPONENTS.map((label, index) => (
                <tr key={index}>
                  <td className="text-center">
                    <Form.Check
                      type="checkbox"
                      checked={selected.includes(label)}
                      onChange={() => handleCheckbox(label)}
                    />
                  </td>
                  <td>{label}</td>
                </tr>
              ))}
            {StudyMode === "DV Mode" &&
              DVCOMPONENTS?.map((label, index) => (
                <tr key={index}>
                  <td className="text-center">
                    <Form.Check
                      type="checkbox"
                      checked={selected.includes(label)}
                      onChange={() => handleCheckbox(label)}
                    />
                  </td>
                  <td>{label}</td>
                </tr>
              ))}
            {(StudyMode === "Live Mode" || StudyMode === "QC Mode") &&
              LIVEQCCOMPONENTS?.map((label, index) => (
                <tr key={index}>
                  <td className="text-center">
                    <Form.Check
                      type="checkbox"
                      checked={selected.includes(label)}
                      onChange={() => handleCheckbox(label)}
                    />
                  </td>
                  <td>{label}</td>
                </tr>
              ))}
          </tbody>
        </Table>
      </Offcanvas.Body>

      <div className="text-end p-2 border-top">
        <button
          className="updateProfile"
          onClick={() => updateStudyDashboardComponent()}
          disabled={buttonLoader}
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Adding...
            </div>
          ) : (
            "Add Component"
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default AddComponents;
